import i18next from 'i18next';

import { initI18next } from '@growtherapy/i18n';

import { logger } from '../datadog/logger';
import { CROWDIN_DISTRIBUTION_HASH, NS_TELEHEALTH_CORE } from './constants';
import { externalNamespaces } from './externalResources';
import { getStoredLanguagePreference } from './languagePreference';
import { ADDITIONAL_SUPPORTED_LOCALES } from './locales';
import { telehealthCoreResoucesEn } from './resources';

export const initI18n = (): void => {
  initI18next(i18next, {
    lng: getStoredLanguagePreference(),
    ns: [NS_TELEHEALTH_CORE, ...externalNamespaces],
    defaultNS: [NS_TELEHEALTH_CORE, ...externalNamespaces],
    resources: telehealthCoreResoucesEn,
    additionalSupportedLngs: ADDITIONAL_SUPPORTED_LOCALES,
    otaOptions: {
      distributionHash: CROWDIN_DISTRIBUTION_HASH,
      otaLanguages: ADDITIONAL_SUPPORTED_LOCALES,
    },
    missingKeyHandler: (lngs, ns, key) => {
      logger.error(`[i18n] Missing translation key: ${key} ns: ${ns} lng: ${lngs} service: telehealth`);
    },
  });
};
